import React from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import withStyles from "elevate-ui/withStyles";
import Input from "elevate-ui/Input";
import classNames from "classnames";
import Button from "elevate-ui/Button";
import Typography from "elevate-ui/Typography";

type Props = {
  classes: Object,
  className: string,
};

const ForgotPasswordForm = ({ classes, className }: Props) => (
  <div className={classNames(classes.root, className)}>
    <Typography type="heading3" className={classes.heading}>
      Forgot Password?
    </Typography>
    <Typography type="body" className={classes.subHeading}>
      Enter your email address below and we will send you password reset
      instructions if that email address exists in our system.
    </Typography>
    <Formik
      initialValues={{ email: "" }}
      validationSchema={() =>
        Yup.object().shape({
          email: Yup.string()
            .email("Invalid email address")
            .required("Email is required"),
        })
      }
      onSubmit={() => {
        // Manually submit the form using a regular form POST rather than AJAX
        document.getElementById("forgot-password-form").submit();
      }}
      render={({ isSubmitting }) => (
        <Form method="POST" id="forgot-password-form" noValidate>
          <div className={classes.row}>
            <Field id="email" name="email" label="Email" component={Input} />
          </div>
          <Button
            type="submit"
            className={classes.forgotBtn}
            disabled={isSubmitting}
          >
            <span className={classes.forgotText}>
              Send Reset Password Email
            </span>
          </Button>
        </Form>
      )}
    />
    <div className={classes.closingContainer}>
      <div>
        Back to{" "}
        <span>
          <a className={classes.login} href={`/login`}>
            Login.
          </a>
        </span>
      </div>
    </div>
  </div>
);

export default withStyles((theme) => ({
  "@global": {
    body: {
      backgroundColor: "#fff !important",
    },
  },
  root: {
    display: "flex",
    flexDirection: "column",
    maxWidth: "420px",
    padding: "0px 12px",
    margin: "96px auto",
  },
  heading: {
    textAlign: "center",
    marginBottom: theme.spacing.unit * 0.75,
  },
  subHeading: {
    textAlign: "center",
    margin: "auto",
    marginBottom: theme.spacing.unit * 3,
  },
  row: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",

    "& > * + *": {
      marginLeft: theme.spacing.unit * 0.75,
    },
  },
  closingContainer: {
    display: "flex",
    flexDirection: "column",
    color: theme.colors.gray["500"],
    fontWeight: "600",
    fontSize: "18px",
    marginTop: theme.spacing.unit * 5,
    margin: "0 auto",

    "& > * + *": {
      marginTop: theme.spacing.unit,
    },
  },
  forgotBtn: {
    width: "100%",
    height: "54px",
    margin: "16px 0",
    fontSize: "24px",
    fontWeight: "600",
  },
  forgotText: {
    fontSize: "16px",
    letterSpacing: ".4px",
  },
  login: {
    color: `${theme.colors.gray["900"]} !important`,
    textDecoration: "underline",

    "&:hover": {
      textDecoration: "none !important",
    },
  },
}))(ForgotPasswordForm);
